import { FC } from 'react';
import Head from 'next/head';

import { PATHS, PROD_URL } from '../../constants';
import { Breadcrumb } from '../../types/api/v4/boats/search';
import appendTrailingSlash from '../../utils/appendTrailingSlash';

type BreadcrumbListSchemaProps = {
  breadcrumbs: Breadcrumb[];
};

const BreadcrumbListSchema: FC<BreadcrumbListSchemaProps> = ({
  breadcrumbs = [],
}) => {
  if (!Array.isArray(breadcrumbs)) {
    return null;
  }

  const filteredBreadcrumbs = breadcrumbs.filter((b) => b.indexed);

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: filteredBreadcrumbs.map(({ name, slug }, index) => {
      const path = PATHS.SEARCH === `/${slug}/` ? PATHS.SEARCH : PATHS.SEARCH + slug;
      const breadcrumbName = name === 'United States' ? 'US' : name;
      return ({
        '@type': 'ListItem',
        name: breadcrumbName,
        position: index + 1,
        item: appendTrailingSlash(
          PROD_URL + path,
        ),
      });
    }),
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
    </Head>
  );
};

export default BreadcrumbListSchema;
